export const TICKET_STATUS_LABELS: Record<string, string> = {
  just_created: 'Just Created',
  in_process: 'In Process',
  replied: 'Replied',
  closed: 'Closed',
};

export const TICKET_CATEGORY_LABELS: Record<string, string> = {
  login: 'Login',
  program: 'Program',
  billing: 'Billing',
  general: 'General',
  others: 'Others',
};

export const TICKET_CATEGORIES = Object.keys(TICKET_CATEGORY_LABELS) as Array<
  keyof typeof TICKET_CATEGORY_LABELS
>;

export function studentInitials(name?: string): string {
  if (!name?.trim()) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ''}${parts[parts.length - 1][0] ?? ''}`.toUpperCase();
}

export function ticketCategoryChipClass(): string {
  return 'bg-accent text-accent-foreground';
}

export function ticketStatusChipClass(status: string): { chip: string; dot: string } {
  switch (status) {
    case 'just_created':
      return { chip: 'bg-info/10 text-info', dot: 'bg-info' };
    case 'in_process':
      return { chip: 'bg-success/10 text-success', dot: 'bg-success' };
    case 'replied':
      return { chip: 'bg-warning/10 text-warning', dot: 'bg-warning' };
    case 'closed':
      return { chip: 'bg-muted text-muted-foreground', dot: 'bg-muted-foreground' };
    default:
      return { chip: 'bg-muted text-muted-foreground', dot: 'bg-muted-foreground' };
  }
}
